import { Injectable } from '@angular/core';

import { RepositoryService } from '@get/services/repository';
import { GeneratedSocieteApiService } from './societe-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class SocieteApiService extends GeneratedSocieteApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
